import * as actions from '../actions/types';

export const initialState = {
  filteringActions: { data: [], error: null, loading: true },
  filteringChips: { data: [] },
  filteringLocations: { data: [], error: null, loading: true },
  filteringPerformers: { data: [], error: null, loading: true },
};

export default function activitiesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_FILTERING_ACTIONS:
      return { ...state, filteringActions: action.value };
    case actions.SET_FILTERING_LOCATIONS:
      return { ...state, filteringLocations: action.value };
    case actions.SET_FILTERING_PERFORMERS:
      return { ...state, filteringPerformers: action.value };
    case actions.SET_FILTERING_CHIPS:
      return { ...state, filteringChips: action.value };
    default:
      return state;
  }
}
